import { render } from "./DeleteVeterinarianDialog.vue?vue&type=template&id=6269d668"
import script from "./DeleteVeterinarianDialog.vue?vue&type=script&lang=js"
export * from "./DeleteVeterinarianDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__